import {
	ChangeDetectorRef,
	Component,
	Input,
	output,
	Renderer2,
	TemplateRef,
	ChangeDetectionStrategy,
} from "@angular/core";
import { DataViewComponent } from "common/data/data-view.component";
import { NotificationService } from "core/notification.service";
import { SelectionStoreService } from "common/selection/state/selection-store.service";
import { SelectionRepository } from "common/selection/state/selection.repository";
import { AsyncPipe, NgClass, NgTemplateOutlet } from "@angular/common";
import { TranslateModule } from "@ngx-translate/core";
import { AddComponent } from "./add.component";
import { AutoCompleteSearchComponent } from "common/autoCompleteSearch/auto-complete-search.component";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { TextFilterComponent } from "./text-filter.component";
import { PagerComponent } from "common/paging/pager.component";
import { SpinComponent } from "common/spin/spin.component";
import { ButtonsBottomComponent } from "common/buttons/buttons-bottom.component";
import { SelectionStoreIsSelectedPipe } from "common/selection/selectionstore-is-selected.pipe";
import { SelectionStoreIsPartiallySelectedPipe } from "common/selection/selectionstore-is-partially-selected.pipe";
import { LayoutService, Size } from "core/layout.service";
import { Observable } from "rxjs";

@Component({
	selector: "stages-responsive-data-view",
	templateUrl: "./responsive-data-view.component.html",
	styleUrls: ["./responsive-data-view.component.scss"],
	changeDetection: ChangeDetectionStrategy.Eager,
	imports: [
		TranslateModule,
		NgTemplateOutlet,
		AddComponent,
		AutoCompleteSearchComponent,
		NgClass,
		ReactiveFormsModule,
		FormsModule,
		TextFilterComponent,
		PagerComponent,
		SpinComponent,
		ButtonsBottomComponent,
		AsyncPipe,
		SelectionStoreIsSelectedPipe,
		SelectionStoreIsPartiallySelectedPipe,
	],
})
export class ResponsiveDataViewComponent<T> extends DataViewComponent<T> {
	@Input()
	listItemTemplate?: TemplateRef<unknown>;

	// TODO: Skipped for migration because:
	//  This input is used in a control flow expression (e.g. `@if` or `*ngIf`)
	//  and migrating would break narrowing currently.
	@Input()
	listHeaderTemplate?: TemplateRef<unknown>;

	// TODO: Skipped for migration because:
	//  This input is used in a control flow expression (e.g. `@if` or `*ngIf`)
	//  and migrating would break narrowing currently.
	@Input()
	informationTemplate?: TemplateRef<unknown>;

	// TODO: Skipped for migration because:
	//  Class of this input is manually instantiated. This is discouraged and prevents
	//  migration.
	@Input()
	listStyles = "list";

	// TODO: Skipped for migration because:
	//  Class of this input is manually instantiated. This is discouraged and prevents
	//  migration.
	@Input()
	autoCompleteBrowseTemplatePragraphStyles = "";

	// TODO: Skipped for migration because:
	//  Class of this input is manually instantiated. This is discouraged and prevents
	//  migration.
	@Input()
	browseItemButtonActive: boolean = false;

	readonly closeBrowserButtonPressed = output<boolean>();

	readonly openBrowserButtonPressed = output<boolean>();

	// TODO: Skipped for migration because:
	//  Class of this input is manually instantiated. This is discouraged and prevents
	//  migration.
	@Input()
	tableItemTemplate?: TemplateRef<unknown>;

	// TODO: Skipped for migration because:
	//  This input is used in a control flow expression (e.g. `@if` or `*ngIf`)
	//  and migrating would break narrowing currently.
	@Input()
	headerTemplate?: TemplateRef<unknown>;

	// TODO: Skipped for migration because:
	//  Class of this input is manually instantiated. This is discouraged and prevents
	//  migration.
	@Input()
	tableColumns: number | string = 1;

	// TODO: Skipped for migration because:
	//  Class of this input is manually instantiated. This is discouraged and prevents
	//  migration.
	@Input()
	filterPlaceholder?: string;

	// TODO: Skipped for migration because:
	//  Class of this input is manually instantiated. This is discouraged and prevents
	//  migration.
	@Input()
	searchPlaceholder?: string;

	@Input()
	filterTemplate?: TemplateRef<unknown>;

	size$: Observable<Size>;

	private readonly defaultPlaceholder = "start.typing";

	constructor(
		chRef: ChangeDetectorRef,
		notificationService: NotificationService,
		renderer: Renderer2,
		selectionStoreService: SelectionStoreService,
		selectionRepository: SelectionRepository,
		layoutService: LayoutService,
	) {
		super(chRef, notificationService, renderer, selectionStoreService, selectionRepository);
		this.size$ = layoutService.size.asObservable();
	}

	getSearchPlaceHolder(): string {
		return this.searchPlaceholder ?? this.defaultPlaceholder;
	}

	getFilterPlaceHolder(): string {
		return this.filterPlaceholder ?? this.defaultPlaceholder;
	}

	isSelectAllEnabled(): boolean {
		return this.selectable && this.showSelectAllSwitch() && this.hasItems;
	}

	isSelectDeselectButtonsEnabled(): boolean {
		return this.selectable && this.showSelectDeselectButtons() && this.hasItems;
	}

	showListTemplate(size: Size): boolean {
		return size === Size.XXSMALL || size === Size.XSMALL;
	}

	openButtonPressed(): void {
		this.openBrowserButtonPressed.emit(true);
	}

	closeButtonPressed(): void {
		this.closeBrowserButtonPressed.emit(true);
	}
}
